// /podmienky — Blok 4, Týž. 17. Nie je to právne poradenstvo, viď docs/00 §5 — pred
// reálnym komerčným spustením odporúčame nechať potvrdiť právnikom.
export function TermsPage() {
  return (
    <main className="page page-narrow">
      <h1 style={{ fontSize: '1.4rem' }}>Podmienky používania</h1>
      <p style={{ color: 'var(--slate)', fontSize: '0.85rem' }}>Platné od 12. júla 2026</p>

      <div style={{ color: 'var(--ink)', fontSize: '0.92rem', lineHeight: 1.7 }}>
        <h3 style={sectionH}>0. Prevádzkovateľ</h3>
        <p>
          [Presný právny názov spoločnosti], so sídlom [adresa], IČO: [doplniť], zapísaná v
          Obchodnom registri [Okresný súd ..., oddiel ..., vložka č. ...]. Kontakt:{' '}
          <a href="mailto:info@marstein.sk">info@marstein.sk</a>, tel.: [doplniť]. Orgán dozoru vo
          veciach ochrany spotrebiteľa: Slovenská obchodná inšpekcia (SOI), [adresa príslušného
          inšpektorátu podľa sídla], www.soi.sk.
        </p>
        <p style={{ color: 'var(--slate-light)', fontSize: '0.78rem' }}>
          [TODO pred komerčným spustením: doplniť skutočné registračné údaje — §4 ods. 1 zákona č.
          22/2004 Z. z. o elektronickom obchode vyžaduje presne tieto polia u poskytovateľa
          elektronickej služby.]
        </p>

        <h3 style={sectionH}>1. Čo je Corpuls</h3>
        <p>
          Corpuls (prevádzkovaný ako súčasť rodiny produktov Marstein, „my", „nás") je webová služba
          na vyhľadávanie verejne dostupných údajov o slovenských firmách a živnostníkoch — profil
          firmy, história účtovných závierok, graf prepojení osôb a firiem, a orientačné rizikové
          skóre.
        </p>

        <h3 style={sectionH}>2. Informatívny charakter údajov</h3>
        <p>
          <b>
            Všetky zobrazené údaje majú výhradne informatívny charakter a nie sú právne záväzné.
          </b>{' '}
          Nepredstavujú úradný výpis z registra, právne poradenstvo, investičné odporúčanie ani
          záväzné stanovisko o bonite či dôveryhodnosti firmy. Rizikové skóre (vrátane Altman Z"
          skóre) je orientačná heuristika — nie je to predikcia budúcnosti a nesmie sa používať ako
          jediný podklad pre finančné, právne alebo obchodné rozhodnutia. Pred akýmkoľvek záväzným
          úkonom si údaje vždy over v oficiálnom zdroji (Obchodný register, ORSR, register účtovných
          závierok).
        </p>

        <h3 style={sectionH}>3. Zdroje dát</h3>
        <p>
          Údaje čerpáme z verejných registrov: Register právnických osôb (ŠÚ SR, licencia CC-BY
          4.0), Register účtovných závierok (MF SR, licencia CC0), Register partnerov verejného
          sektora, register diskvalifikovaných osôb (ISU) a Slovensko.Digital datahub (Register
          právnických osôb V2). Nemeníme pôvodné hodnoty týchto registrov — naše skóre a odvodené
          výpočty sú vždy jasne označené ako vlastný produkt, oddelene od surových registrových dát.
        </p>

        <h3 style={sectionH}>4. Používateľský účet</h3>
        <p>
          Základné vyhľadávanie a zobrazenie profilu firmy nevyžaduje registráciu. Účet potrebuješ
          len na sledovanie firiem (watchlist) a alerty. Free plán umožňuje sledovať max. 5 firiem
          naraz; Pro plán (platené predplatné) umožňuje neobmedzené sledovanie. Zodpovedáš za
          ochranu prístupu k svojmu účtu a za pravdivosť zadaných údajov.
        </p>

        <h3 style={sectionH}>5. Predplatné a platby</h3>
        <p>
          Platby spracúva Stripe. Predplatné sa automaticky obnovuje, kým ho nezrušíš v nastaveniach
          účtu. Podrobné fakturačné podmienky (vrátane práva na odstúpenie do 14 dní pri prvom
          predplatnom) budú doplnené pri spustení platenej vrstvy.
        </p>

        <h3 style={sectionH}>6. Obmedzenie zodpovednosti</h3>
        <p>
          Službu poskytujeme „tak ako je", bez záruky neprerušenej dostupnosti alebo úplnej
          presnosti dát prevzatých z tretích zdrojov. V rozsahu povolenom zákonom nezodpovedáme za
          škodu vzniknutú spoľahnutím sa na zobrazené údaje. Týmto obmedzením nie je dotknutá
          zodpovednosť za škodu spôsobenú úmyselne alebo hrubou nedbanlivosťou, ani zodpovednosť,
          ktorej vylúčenie alebo obmedzenie zákon nepripúšťa (najmä §53 Občianskeho zákonníka pri
          spotrebiteľských zmluvách).
        </p>

        <h3 style={sectionH}>7. Kontakt</h3>
        <p>
          Otázky k týmto podmienkam: <a href="mailto:info@marstein.sk">info@marstein.sk</a>.
        </p>

        <p style={{ color: 'var(--slate-light)', fontSize: '0.78rem', marginTop: '2rem' }}>
          Tento dokument nie je právne poradenstvo a bude pred plným komerčným spustením
          doplnený/potvrdený právnikom.
        </p>
      </div>
    </main>
  );
}

const sectionH = { fontSize: '1.02rem', marginTop: '1.6rem', color: 'var(--navy-900)' } as const;
